export default __webpack_public_path__ + "static/media/img-0106-canada-full-face.faf4301c.png";